/**
 * @generated SignedSource<<3ac2be925269c14a6a51074d6cd7dfed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassesStudentWithManyClassesQuery$variables = {
  skip?: boolean | null | undefined;
  userId: string;
};
export type ClassesStudentWithManyClassesQuery$data = {
  readonly isUserInMoreThanOneClass?: boolean;
};
export type ClassesStudentWithManyClassesQuery = {
  response: ClassesStudentWithManyClassesQuery$data;
  variables: ClassesStudentWithManyClassesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          }
        ],
        "kind": "ScalarField",
        "name": "isUserInMoreThanOneClass",
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassesStudentWithManyClassesQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ClassesStudentWithManyClassesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a950af6da5c0f48d727da07b04a46c0d",
    "id": null,
    "metadata": {},
    "name": "ClassesStudentWithManyClassesQuery",
    "operationKind": "query",
    "text": "query ClassesStudentWithManyClassesQuery(\n  $userId: ID!\n  $skip: Boolean = false\n) {\n  isUserInMoreThanOneClass(userId: $userId) @skip(if: $skip)\n}\n"
  }
};
})();

(node as any).hash = "3ca91aa08e7e0d2be037fe2cb5bcad5a";

export default node;
